import React from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import * as CurrencyFormat from 'react-currency-format';
import _adviserPortalHome from './_adviserPortalHome';

function CommissionPayment(props) {
    const { t } = props;
    const commissionPaymentDetails = _adviserPortalHome._commissionPaymentDetails(props)

    return (
        <div >
             <div>
                <Link className="adviserLoginLink link" to="/adv/commissionPayment">
                    {t('Fees:fee')}

                </Link>
            </div>
            {/* <div style={{padding: "10px 0px"}}>
                <div>
                    <Link className="adviserLoginDataLink link" to="/adv/commissionPayment">
                        <div className="adviserDataMembers"> <CurrencyFormat value={Number(commissionPaymentDetails.currentFee).toFixed(2)}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'} />
                        </div></Link>
                </div>

                <div>
                    <Link className="adviserLoginDataLink link" to="/adv/commissionPayment">
                        <div>{t('Fees:nextPayment')}</div>
                        <div>{commissionPaymentDetails.current[0].month}</div></Link>
                </div>
            </div>          */}
            <div style={{padding: "10px 0px"}}>
                <div>
                    <Link className="adviserLoginDataLink link" to="/adv/commissionPayment">
                        <div className="adviserDataMembers"> <CurrencyFormat value={Number(commissionPaymentDetails.previousFee).toFixed(2)}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'} />
                        </div></Link>
                </div>

                <div>
                    <Link className="adviserLoginDataLink link" to="/adv/commissionPayment">
                        <div>{t('Fees:prevPayment')}</div>
                        <div>{commissionPaymentDetails.previous[0].month}</div></Link>
                </div>
            </div>
        </div>
        // <div style={{marginLeft: "auto", marginRight: "auto", paddingTop: "10px"}}>
        //     <table className="adviserLogin">
        //     <tr>
        //         <th><Link className="adviserLoginLink link" to="/adv/commissionPayment">
        //                 {t('commission')+" "+t('payment')+" "+t('due')+" "+t("on")}</Link></th>
        //     </tr>
        //     </table>
        //     <table className="adviserLogin adviserLoginData">
        //         <tr>
        //             <th><Link className="adviserLoginDateLink link" to="/adv/commissionPayment">
        //                     {commissionPaymentDetails.current[0].month}
        //                 </Link></th>
        //             <td style={{color: "#333333", fontSize: "16px"}}>
        //                 <CurrencyFormat value={Number(commissionPaymentDetails.currentFee).toFixed(2)}
        //                     displayType={'text'}
        //                     thousandSeparator={true}
        //                     prefix={'$'} />
        //                 </td>
        //         </tr>
        //     </table>
        // </div>
    );
}

export default withTranslation()(CommissionPayment);